export default __webpack_public_path__ + "static/media/24H_Dark_Orange.b7248f21.png";